/**
 * 사업 API 파사드 — 사업 상세(specs/025)·사업 연도 선택지(specs/032).
 * 계약: `GET /api/fo/ws/programs/{programYearId}?companyId=` · `GET /api/fo/ws/programs/years`
 *  · `GET /api/fo/ws/programs/{programYearId}/target-companies`(specs/059)
 */
import type { ProgramYears } from '@/features/program-year/types';
import type { ProgramDetailViewResponse, ProgramTargetCompanies } from '@/features/program/types';

import { http, withErrors } from './http';

/**
 * 사업 상세 조회 — 연도는 `programYearId` 에 확정돼 있어 별도 파라미터가 없다(FR-001a).
 * `companyId` 는 판정 맥락 전용 — 생략하면 응답의 `judgement` 가 null 이고 사업 원문만 표시된다(FR-016).
 */
export async function getProgramDetail(
  programYearId: number,
  companyId?: number,
): Promise<ProgramDetailViewResponse> {
  const { data } = await http.get<ProgramDetailViewResponse>(
    `/fo/ws/programs/${programYearId}`,
    withErrors({ silentStatuses: [404] }, { params: companyId === undefined ? {} : { companyId } }),
  );
  return data;
}

/** 사업 연도 선택지 — 판정 가능 데이터가 있는 연도(최신순)와 기본 연도. 데이터 없으면 `years=[]`·`defaultYear=null`. */
export async function getProgramYears(): Promise<ProgramYears> {
  const { data } = await http.get<ProgramYears>('/fo/ws/programs/years');
  return data;
}

/** 사업 기준 내 업체 대상(specs/059) — 담당 업체 전체의 그 사업 판정·업력 경계일. 사업 상세와 같은 404 게이팅. */
export async function getProgramTargetCompanies(
  programYearId: number,
): Promise<ProgramTargetCompanies> {
  const { data } = await http.get<ProgramTargetCompanies>(
    `/fo/ws/programs/${programYearId}/target-companies`,
    withErrors({ silentStatuses: [404] }),
  );
  return data;
}
